// Auto-generated imports for web dependencies
import "bootstrap-datepicker";
import "htmx.org";
import "bootstrap/scss/bootstrap.scss";
import "bootstrap";
import "bootstrap-icons/font/bootstrap-icons.scss";
import "htmx-ext-json-enc";
import "htmx-ext-response-targets";
import "jquery";

// Auto-generated imports for project sources
import "./web/eldix.css";
export * from "./web/eldix";

